import React from 'react'
import Bredcom from '../../Bradcom/Main'
import First from '../../Menpages/Menshops/First'

const Main = () => {
  return (
    <>
        <main>
            <Bredcom title={"Shop"} subtitle={"Home"} newtitle={"Shop"}/>
            <First/>
        </main>
    </>
  )
}

export default Main